<template>
  <section>
    <left-menu />

    <div id="mainContent" class="list-holiday">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 box-content-title-page">
          <h1 class="certa">{{$t("Férias e afastamentos")}}</h1>
          <router-link class="btn-title" to="/solicitacao-de-ferias-afastamento">{{$t("Solicitar Férias ou Afastamento")}}</router-link>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
          <!-- Box Filter -->
          <div class="col-xs-12 col-sm-12 col-md-12 default-box filter-box">
            <!-- Values -->
            <form name="form" novalidate>
              <div class="col-xs-12 col-sm-12 col-md-12">
                <h2 class="certa filter-title">{{$t("Minhas férias e afastamentos")}}</h2>
              </div>
                <div class="col-xs-12 col-sm-6 col-md-2 offset-top-20">
                  <div class="input-with-date">
                    <label>{{$t("Período")}}</label>
                    <datepicker
                      v-model="initialDate"
                      minimum-view="year"
                      :format="datePickerFormat"
                      :language="ptBR"/>
                    <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                  </div>
                </div>

              <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
                <button class="btn-search" v-on:click="searchRequestDate()" type="button">{{$t("Pesquisar")}}</button>
              </div>
            </form>
            <div class="col-xs-12 col-sm-12 col-md-12">
              <!-- Loading -->
              <div v-if="loadingList" class="loader-page-content">
                <div class="spinner">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <div v-if="listHoliday.length" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
                <div class="table-responsive table-clean">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="certa no-wrap">{{$t("Tipo")}}</th>
                      <th class="certa no-wrap">{{$t("Data de início e fim<")}}</th>
                      <th class="certa no-wrap">{{$t("Qtde de dias")}}</th>
                      <th class="certa no-wrap">{{$t("Motivo")}}</th>
                      <th class="certa no-wrap">{{$t("Situação")}}</th>
                      <th class="certa no-wrap">{{$t("Ação")}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="r in listHoliday">
                      <td>
                        <p>{{r.userVacationTypeStr}}</p>
                      </td>
                      <td>
                        <p>{{r.initDate | formatDate}} - {{r.endDate | formatDate}}</p>
                      </td>
                      <td>
                        <p>{{r.totalDays}} {{r.totalDays <= 1 ? $t('dia'): $t("dias")}}</p>
                      </td>
                      <td>
                        <p>{{r.requestNotes ? r.requestNotes : '-'}}</p>
                      </td>
                      <td>
                        <div class="content-status" v-bind:class="{'status-warning': r.userVacationStatus === 1, 'status-invalid': r.userVacationStatus >= 3, 'status-success': r.userVacationStatus === 2}">
                          <span>{{r.userVacationStatusStr}}</span>
                        </div>
                      </td>
                      <td>
                        <router-link v-bind:to="'/detalhes-da-ferias-afastamento/' + r.id" title="Visualizar" class="view-more">{{$t("Visualizar")}}</router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="!listHoliday.length && !failRequest && !loadingList" class="col-xs-12 col-sm-12 col-md-12 box-empty offset-top-40">
                <img src="../../../../assets/img/empty/comunicados.png" alt="Comunicado" class="img-fluid" />
                <p class="offset-top-30">{{$t("Nenhuma solicitação de férias ou afastamento cadastrada no Ano selecionado.")}}</p>
              </div>

              <div v-if="!listHoliday.length && failRequest" class="col-xs-12 col-sm-12 col-md-12 offset-top-40 box-empty">
                <img src="../../../../assets/img/empty/internet.png" alt="internet" class="img-fluid img-responsive" />
                <p class="nunito">{{$t("Tivemos um problema com a conexão, tente novamente atualizando a página.")}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
import leftMenu from '../../components/leftMenu.vue'
import vueFooter from "../../components/footer";
import fullLoading from "../../components/blueFullLoading";
import datepicker from 'vuejs-datepicker';
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import moment from 'moment';
import MugenScroll from 'vue-mugen-scroll';
import swal from 'sweetalert';
import Autocomplete from 'vue2-autocomplete-js'

import { ABSENCE_EMPLOYEE, ABSENCE_EMPLOYEE_ADMIN } from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";

export default {
  name: 'list-holiday',
  components: {
    fullLoading,
    leftMenu,
    vueFooter,
    datepicker,
    Autocomplete,
    MugenScroll
  },
  data() {
    return {
      initialDate: new Date(),
      datePickerFormat: 'yyyy',
      ptBR: ptBR,
      listHoliday: [],
      userInfo: null,
      failRequest: false,
      loadingList: false
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      this.listHoliday = [];
      REQUEST_SERVICE.post(ABSENCE_EMPLOYEE, {i: this.userInfo.id, year: moment(this.initialDate).format('YYYY')}).then((response) => {
        UTIL_SERVICE.console("RESULT ABSENCE_EMPLOYEE:", response.data);

        this.listHoliday = response.data;

        this.loadingList = false;
      }).catch(reason => {
        this.loadingList = false;
        // Show errors.
        reason.response.data.erros.map((value, index) => {
          swal(this.$t("Aviso"), value.value, "error");
        });
      });
    },
    searchRequestDate() {
      this.getList();
    }
  },
  beforeMount(){
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    this.getList();
  }
}
</script>


<style lang="scss" scoped>
.list-holiday {
  .filter-box {
    margin-bottom: 80px;
    padding-bottom: 40px;
  }

  .box-empty {
    margin-top: 30px;

    p {
      font-family: "Montserrat", sans-serif;
      color: var(--defaultText);
    }
  }

  .box-content-title-page {
    position: relative;

    .btn-title {
      position: absolute;
      top: 18px;
      right: 16px;
      min-width: 225px;
      height: 39px;
      line-height: 39px;
      text-align: center;
      text-decoration: none;
      background: var(--linkColor);
      border-radius: 4px;
      font-family: "Montserrat", sans-serif;;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .filter-title {
    margin-top: 30px;
    margin-bottom: 0;
    font-family: "Montserrat", sans-serif;;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    color: var(--textSide);
  }

  .btn-search {
    background: var(--linkColor);
    width: 100%;
    max-width: 109px;
    height: 36px;
    cursor: pointer;
    margin-top: 15px;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
    border-radius: 4px;
    border: none;

    &:hover {

    }
  }

  .content-status {
    max-width: 100px;
    min-width: 90px;
    width: 100%;
    text-align: center;
    background: var(--bodyColor);
    height: 30px;
    border-radius: 40px;
    padding: 4px 0;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #FFFFFF;
  }

  .status-success {
    background: #2ACC6B;
  }
  .status-warning {
    color: #3A424E;
    background: #FDD944;
  }
  .status-invalid {
    background: #FF445D;
  }

  .view-more {
    line-height: 20px;
    min-width: 90px;
    font-weight: 500;
    max-width: 99px;
    padding: 4px 0;
    height: 30px;
    width: 100%;
    display: block;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    text-align: center;
    font-size: 12px;
    border-radius: 40px;
    cursor: pointer;
    color: var(--linkColor);
    border: 1px solid var(--linkColor);

    &:hover {
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/holiday/listHoliday.vue